export default (props, vars) => props?.['name'] === 'directional-down';
